import { Form, Input, Spin } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../layout/BreadCrumb";
import { save } from "../../features/save/saveSlice";
import ReactPasswordChecklist from "react-password-checklist";
import toast from "react-hot-toast";
import { logout } from "../../features/auth/authSlice";
import { clearObj } from "../../features/obj/objSlice";
import svgone from "../../assets/svg/svgone.svg";

function ResetPassword() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving,   } = useSelector((state) => state.save);
    const {  user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  async function handleLogout() { 
    await dispatch(logout());
    await localStorage.clear();
    await dispatch(clearObj());
    await navigate("/login");
  }

  const handleCancel = () => {
    navigate("/dashboard");
  };

  const onFinish = async (data) => {
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[A-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(password) &&
      password === confirmPassword;
    if (!isPasswordValid) {
      toast.error(
        "Password does not meet the required conditions or does not match"
      );
      return;
    }

    const res = await dispatch(
      save({
        password: data?.password,
        email:user?.sub,
        url: "api/v1/users",
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
      await handleLogout();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };
 
  return (
    <div>
      <BreadCrumb breadcrumbs={[{ title: "Reset Password" }]} />
      <div className="white_card mt-[1.5rem] flex-1 min-h-[80vh]">
        <div className="flex flex-col  lg:w-[50%] w-full h-full">
          <div className="text-[#2D3E8D] text-[1.5rem] font-[600]">
            Reset Password
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="w-full mt-[2.25rem]"
            form={form}
          >
            <Form.Item
              label="New Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your new password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <Form.Item
              label="Confirm password"
              name="usrEncryptedPasswordAlt"
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <div className="mt-[.32rem]">
              <ReactPasswordChecklist
                className="text-darkBlue flex flex-col items-start gap-1 w-full text-sm sm:text-base md:text-lg"
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                messages={{
                  minLength: "A minimum of 8 characters",
                  number: "At least one number (0-9)",
                  capital: "At least one upper case letter (A-Z)",
                  match: "Confirm password to match with the password",
                  specialChar:
                    "At least one special character e.g !@#$%^&*()_+{}[]:;?/|\\",
                }}
                iconComponents={{
                  ValidIcon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-darkBlue"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  ),
                  InvalidIcon: (
                    <img
                      className="pr-1 sm:pr-2 w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
                      src={svgone}
                      alt="lazy"
                    />
                  ),
                }}
                validColor="#147CBC"
                iconSize={20}
              />
            </div>

            <div className="flex justify-between mt-[1.25rem] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button
                    disabled={saving}
                    key="submit"
                    type="submit"
                    className="cstm-btn-2"
                  >
                    {saving ? <Spin /> : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
